module.exports = __webpack_public_path__ + "static/media/Subscription-Management.dc3087ac.svg";